import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "jobs-panel-search" }
const _hoisted_2 = { class: "jobs-panel-search__header" }
const _hoisted_3 = { class: "jobs-panel-search__header-inputs" }
const _hoisted_4 = { class: "jobs-panel-search__header-inputs-item" }
const _hoisted_5 = { class: "jobs-panel-search__header-inputs-item" }
const _hoisted_6 = { class: "jobs-panel-search__row jobs-panel-search__row--checkboxes" }
const _hoisted_7 = { class: "jobs-panel-search__chip-count" }
const _hoisted_8 = { class: "jobs-panel-search__chip-count" }
const _hoisted_9 = {
  key: 0,
  class: "jobs-panel-search__row jobs-panel-search__row--toggle"
}
const _hoisted_10 = {
  key: 1,
  class: "jobs-panel-search__tags"
}
const _hoisted_11 = { class: "jobs-panel-search__tags-item-name" }

import {
	computed,
	onMounted,
	ref,
	watch
} from "vue";
import {useRoute, useRouter} from "vue-router";
import {jobsStore, JobsContextType} from "@/store/jobs";
import {searchStore} from "@/store/search";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppSelect from "@/components/ui-kit/select/AppSelect.vue";
import {workerStore} from "@/store/worker";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppResizableDropdown from "@/components/ui-kit/dropdown/AppResizableDropdown.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";
import CreateEditJobDropdown from "@/components/main/jobs-panel/dropdowns/CreateEditJobDropdown.vue";
import AppTagSelector from "@/components/ui-kit/tag-selector/AppTagSelector.vue";
import {TagEntityType} from "@/models/etc/types";
import type {TagWithFrequency} from "@/models/interfaces/tags/tag-models";

const listGetCount = 30

export default /*@__PURE__*/_defineComponent({
  __name: 'JobsPanelSearch',
  setup(__props) {

const store = jobsStore()
const userStore = workerStore()
const route = useRoute()
const router = useRouter()
const searchStoreInstance = searchStore()

const currentContext = computed<{ type: JobsContextType; entityId: number | null }>(() => {
	const id = route.query.id != null && route.query.id !== ''
		? Number(route.query.id)
		: null

	if (route.query.page === 'client' && id) {
		return {
			type: 'client', entityId: id
		}
	}

	if (route.query.page === 'project' && id) {
		return {
			type: 'project', entityId: id
		}
	}

	return { type: 'main', entityId: null }
})

const isOnEntity = computed(() => currentContext.value.type !== 'main')
const isOnClient = computed(() => currentContext.value.type === 'client')

const routeJobId = computed<number | null>(() => {
	const raw = route.query.jobId
	if (raw == null || Array.isArray(raw) || raw === '') {
		return null
	}
	const id = Number(raw)
	return Number.isFinite(id) && id > 0 ? id : null
})
const clientSearch = computed(() => store.context.clientSearch)
const holdingSearch = computed(() => store.context.holdingSearch)

const jobsSearch = ref('')
const selectedPerson = ref<number | null>(null)
const selectedChips = ref<number[]>([])
const chips = [
	{
		id: 1,
		name: 'В работе',
		color: '#86CED2'
	},
	{
		id: 2,
		name: 'Срочно',
		color: '#EE966A'
	},
]

const $createEditJobModal = ref<typeof AppResizableDropdown | null>(null)
const $tagsDropdown = ref<InstanceType<typeof AppResizableDropdown> | null>(null)
const selectedTags = ref<TagWithFrequency[]>([])
const tagsDirty = ref(false)
const counters = computed(() => store.jobsCounter)
const jobWorkers = computed(() => store.jobWorkers)
const userForUpdateJobsList = computed(() => store.userForUpdateJobsList)
const currentUser = computed(() => userStore.workerProfile)
const searchInWork = computed(() => selectedChips.value.includes(1))
const searchIsLost = computed(() => selectedChips.value.includes(2))

const optionsPersons = computed(() => {
	if (!jobWorkers.value) {
		return []
	} else {
		const mappedWorkers = jobWorkers.value.map((el, index) => {
			if (el.IsWorker) {
				return {
					id: el.Worker?.Id,
					label: el.Worker?.Name,
					type: 'item'
				}
			} else {
				return {
					id: index + 999999,
					label: el.Departament.Name,
					type: 'group',
					selectable: true,
					children: el.Departament.Workers?.map(worker => ({
						id: worker.Id,
						label: worker.Name,
						type: 'item'
					}))
				}
			}
		})

		return [
			{
				id: 0,
				label: 'Все',
				type: 'item'
			},
			...mappedWorkers
		]
	}
});

const jobsInit = () => {
	if (currentUser.value) {
		store.getJobWorkers()
	}
}

const onSearch = () => {
	const tagIds = selectedTags.value.length ? selectedTags.value.map(t => t.Id) : null
	store.getJobs(
		jobsSearch.value,
		selectedPerson.value as number,
		tagIds,
		searchInWork.value,
		searchIsLost.value,
		listGetCount,
		0
	)
	store.getJobsCount(
		jobsSearch.value,
		selectedPerson.value as number,
		tagIds
	)
}

const onTagsUpdate = (newTags: TagWithFrequency[]) => {
	selectedTags.value = newTags
	tagsDirty.value = true
}

const onTagsDropdownClose = () => {
	if (tagsDirty.value) {
		tagsDirty.value = false
		onSearch()
	}
}

const onDropTag = (tag: TagWithFrequency) => {
	const wasLast = selectedTags.value.length === 1
	selectedTags.value = selectedTags.value.filter(t => t.Id !== tag.Id)
	if (wasLast) onSearch()
}

const loadAroundJob = async (jobId: number) => {
	const ctx = currentContext.value

	jobsSearch.value = ''
	selectedTags.value = []
	selectedChips.value = []
	tagsDirty.value = false

	store.setContext(ctx.type, ctx.entityId)
	await store.getJobsAroundOne(jobId)
	await store.getJobsCount()
}

const consumeJobNavigationRequest = async () => {
	const req = searchStoreInstance.pendingJobNavigation
	const ctx = currentContext.value
	if (!req || req.type !== ctx.type || req.entityId !== ctx.entityId) return
	searchStoreInstance.clearPendingJobNavigation()

	await loadAroundJob(req.jobId)
}

const consumeRouteJobId = async (jobId: number) => {
	await loadAroundJob(jobId)

	const { jobId: _omit, ...rest } = route.query
	router.replace({ query: rest })
}

const applyContextAndReload = () => {
	const req = searchStoreInstance.pendingJobNavigation
	if (req && req.type === currentContext.value.type && req.entityId === currentContext.value.entityId) {
		consumeJobNavigationRequest()
		return
	}

	store.setContext(currentContext.value.type, currentContext.value.entityId)
	if (!currentUser.value) return

	if (isOnEntity.value && routeJobId.value) {
		consumeRouteJobId(routeJobId.value)
		return
	}

	const targetUserId = isOnEntity.value
		? 0
		: (currentUser.value.Id as number)
	if (selectedPerson.value !== targetUserId) {
		selectedPerson.value = targetUserId
	} else {
		onSearch()
	}
}

onMounted(() => {
	jobsInit()
	applyContextAndReload()
})

watch(
	() => searchStoreInstance.pendingJobNavigation,
	() => consumeJobNavigationRequest()
)

watch(currentUser, (newValue, oldValue) => {
	if (newValue && !oldValue) {
		jobsInit()
		applyContextAndReload()
	}
})

watch(currentContext, (newValue, oldValue) => {
	if (newValue.type !== oldValue?.type || newValue.entityId !== oldValue?.entityId) {
		selectedTags.value = []
		tagsDirty.value = false
		applyContextAndReload()
	}
})

watch(selectedPerson, (newValue, oldValue) => {
	if (newValue !== oldValue && newValue != null) {
		onSearch()
	}
})

watch(userForUpdateJobsList, (newValue, oldValue) => {
	if (newValue && !oldValue) {
		selectedPerson.value = newValue
		jobsSearch.value = ''
		onSearch()
		store.setUserForUpdateJobsList(null)
	}
})

const toggleClientSearch = () => {
	store.setClientSearch(!clientSearch.value)
	onSearch()
}

const toggleHoldingSearch = () => {
	store.setHoldingSearch(!holdingSearch.value)
	onSearch()
}

const toggleChip = (id: number) => {
	if (selectedChips.value.includes(id)) {
		selectedChips.value.splice(selectedChips.value.indexOf(id), 1)
	} else {
		selectedChips.value.push(id)
	}

	onSearch()
}

const chipStyle = (t: any) => {
	const active = selectedChips.value.includes(t.id);
	const base = {
		borderLeftColor: t.color,
		backgroundColor: 'transparent'
	}
	if (active) {
		base.backgroundColor = hexToRgba(t.color, 0.121);
	}

	return base;
}

const chipColoredStyle = (t: any) => {
	return {
		backgroundColor: t.color
	}
}

const hexToRgba = (hex: string, alpha: number) => {
	const res = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!res) return hex;
	const r = parseInt(res[1], 16);
	const g = parseInt(res[2], 16);
	const b = parseInt(res[3], 16);
	return `rgba(${r},${g},${b},${alpha})`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppResizableDropdown, {
        ref_key: "$tagsDropdown",
        ref: $tagsDropdown,
        position: "left",
        "close-by-click-outside": true,
        "max-width": 640,
        "max-height": 436,
        name: "$jobsPanelTags",
        onClose: onTagsDropdownClose
      }, {
        activator: _withCtx(() => [
          _createVNode(AppTooltip, {
            position: "bottom",
            text: "Выбрать тег"
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "jobs-panel-search__add-btn",
                name: "hash",
                width: "20px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer"
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(AppTagSelector, {
            "model-value": selectedTags.value,
            "entity-type": _unref(TagEntityType).Job,
            mode: "filter",
            "onUpdate:modelValue": onTagsUpdate,
            onClose: _cache[0] || (_cache[0] = ($event: any) => ($tagsDropdown.value?.close()))
          }, null, 8, ["model-value", "entity-type"])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(AppSelect, {
            modelValue: selectedPerson.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPerson).value = $event)),
            placeholder: "Выберите пользователя...",
            items: optionsPersons.value,
            "min-dropdown-width": 272,
            searchable: ""
          }, null, 8, ["modelValue", "items"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(AppInput, {
            modelValue: jobsSearch.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((jobsSearch).value = $event)),
            placeholder: _ctx.$t('search_label'),
            "show-search-button": "",
            onPressEnter: onSearch,
            onSearch: onSearch,
            onClearField: onSearch
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createVNode(AppResizableDropdown, {
        position: "right",
        resizable: "",
        "initial-width": 320,
        "initial-height": 398,
        "min-width": 320,
        "max-width": 480,
        "min-height": 398,
        "max-height": 600,
        "close-by-click-outside": false,
        ref_key: "$createEditJobModal",
        ref: $createEditJobModal,
        name: "$createEditJobModal"
      }, {
        activator: _withCtx(() => [
          _createVNode(AppTooltip, {
            position: "top",
            text: "Создать работу"
          }, {
            activator: _withCtx(() => [
              _createVNode(AppIcon, {
                class: "jobs-panel-search__add-btn",
                name: "plus",
                width: "20px",
                color: "#979797",
                "hover-color": "#499259",
                cursor: "pointer"
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(CreateEditJobDropdown, {
            type: "create",
            workers: optionsPersons.value,
            onOnClose: _cache[3] || (_cache[3] = ($event: any) => ($createEditJobModal.value?.close()))
          }, null, 8, ["workers"])
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "jobs-panel-search__chip",
        style: _normalizeStyle(chipStyle(chips[0])),
        onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleChip(chips[0].id)))
      }, [
        _createElementVNode("div", {
          class: "jobs-panel-search__chip-colored",
          style: _normalizeStyle(chipColoredStyle(chips[0]))
        }, null, 4),
        _createElementVNode("div", _hoisted_7, _toDisplayString(`${chips[0].name}: ${counters.value?.Actual || 0}`), 1)
      ], 4),
      _createElementVNode("div", {
        class: "jobs-panel-search__chip",
        style: _normalizeStyle(chipStyle(chips[1])),
        onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleChip(chips[1].id)))
      }, [
        _createElementVNode("div", {
          class: "jobs-panel-search__chip-colored",
          style: _normalizeStyle(chipColoredStyle(chips[1]))
        }, null, 4),
        _createElementVNode("div", _hoisted_8, _toDisplayString(`${chips[1].name}: ${counters.value?.Lost || 0}`), 1)
      ], 4)
    ]),
    (isOnClient.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass({
					'jobs-panel-search__toggle-btn': true,
					'jobs-panel-search__toggle-btn--active': clientSearch.value,
				}),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleClientSearch()))
          }, " Только в клиенте ", 2),
          _createElementVNode("div", {
            class: _normalizeClass({
					'jobs-panel-search__toggle-btn': true,
					'jobs-panel-search__toggle-btn--active': holdingSearch.value,
				}),
            onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleHoldingSearch()))
          }, " С холдингом ", 2)
        ]))
      : _createCommentVNode("", true),
    (selectedTags.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTags.value, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tag.Id,
              class: "jobs-panel-search__tags-item"
            }, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(tag.Name), 1),
              _createVNode(AppIcon, {
                class: "jobs-panel-search__tags-item-delete",
                name: "close-bold",
                width: "12px",
                color: "#D2D2D2",
                "hover-color": "#4D4D4D",
                cursor: "pointer",
                onClick: _withModifiers(($event: any) => (onDropTag(tag)), ["stop"])
              }, null, 8, ["onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})